import { isNil, mergeWith, omitBy } from 'lodash';
import { GetRegistrationInfo } from '../generated-types/GetRegistrationInfo';
import { VariantProps } from '../interfaces/variant';
import { defaultVariant } from '../login-variants';
import { RefcodeVariantMapping, registrationVariants } from '../registration-variants';
import { replaceInterpolatedVariables } from './string-utils';

const getVariantFromRefCode = (refcode: string | null): VariantProps | false => {
  return RefcodeVariantMapping[refcode ?? ''] ?? false;
};

export const getVariantFromQuery = (data?: GetRegistrationInfo): VariantProps => {
  // It's possible the variant might be expired, or have a typo or something.
  // Fall back to the default if no matching variant exists.
  let variant = registrationVariants.primary;

  if (data) {
    if (data.registrationFormData?.marketplace_app?.name) {
      variant = registrationVariants.marketplace;
    } else if (data.registrationFormData?.oauth_app?.name) {
      if (data.registrationFormData.oauth_app.is_internal) {
        variant = registrationVariants.community;
      } else {
        variant = registrationVariants.oauth_app;
      }
    } else if (data.registrationFormData?.team) {
      variant = registrationVariants.team;
    }
  }

  return variant;
};

export const getRegistrationVariant = (refcode: string | null, data?: GetRegistrationInfo): VariantProps => {
  let variant: VariantProps | false = getVariantFromRefCode(refcode);

  if (!variant) {
    variant = getVariantFromQuery(data);
  }

  return replaceInterpolatedVariables(data, variant) as VariantProps;
};

export const getVariant = (variants: VariantProps[]): VariantProps => {
  const total = variants.reduce((prev, curr) => {
    return prev + Number(curr.weight || 0);
  }, 0);

  let variant: VariantProps | null = null;

  const threshold = total * Math.random();

  let weightedSum = 0;
  for (const variantItem of variants) {
    weightedSum += Number(variantItem.weight);
    if (weightedSum >= threshold) {
      variant = variantItem;
      break;
    }
  }

  if (!variant) {
    variant = variants[variants.length - 1];
  }

  return mergeWith({}, defaultVariant, omitBy(variant, isNil));
};
